@if (loading()) {
  <div class="promocode-list">
    @for (item of [1, 2, 3, 4, 5, 6]; track item) {
      <div class="promocode-list__skeleton"></div>
    }
  </div>
} @else if (error()) {
  <p class="promocode-list__empty text-b3-s-500">не удалось загрузить промокоды</p>
} @else if (promocodes().length) {
  <ul class="promocode-list">
    @for (promocode of promocodes(); track promocode.name) {
      <li class="promocode-item">
        <div class="promocode-item__main">
          <button
            class="promocode-item__copy"
            [class.promocode-item__copy--inactive]="promocode.status !== 'ACTIVE'"
            type="button"
            [attr.aria-label]="'скопировать промокод ' + promocode.name"
            (click)="copyPromocode(promocode)"
            [attr.disabled]="promocode.status !== 'ACTIVE' || null"
          >
            <sd-icon class="icon-size-s" [type]="iconTypes.COPY_LINK"></sd-icon>
            <span class="promocode-item__name text-b3-m-700">{{ promocode.name }}</span>
          </button>

          <div class="promocode-item__status">
            @if (promocode.status === 'ACTIVE') {
              <span class="promocode-item__state promocode-item__state--active text-b3-s-500">
                активен до {{ promocode.expiresAt | date: 'dd.MM.yyyy' }}
              </span>
            } @else {
              <span class="promocode-item__state promocode-item__state--inactive text-b3-s-500">недействителен</span>
            }
          </div>
        </div>

        <span
          class="promocode-item__percents text-b3-m-500"
          [class.promocode-item__percents--inactive]="promocode.status !== 'ACTIVE'"
        >
          {{ promocode.bonusPercent }}% / {{ promocode.discountPercent }}%
        </span>
      </li>
    }
  </ul>

  @if ((pagination().totalPages ?? 1) > 1) {
    <sd-pagination [pagination]="pagination()" [defaultPage]="0" (viewPageEvent)="changePage($event)"></sd-pagination>
  }
} @else {
  <p class="promocode-list__empty text-b3-s-500">у вас пока нет промокодов</p>
}
